import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
const LOG = Logger.getLogger('handleSurveySubmissionResponse');
export const handlePostSignupError = (error = {}) => {
  LOG.error('Post Signup failed.', {
    extra: getSentryExtra(error)
  });
};